import { Container, Typography, Box } from "@mui/material";
import { Fake } from "components/layout/skeleton/Fake";
import { VideoPlayerSkeleton } from "components/video/VideoPlayerSkeleton";

export const EventWatchPageSkeleton = () => (
    <Container className="skeleton" sx={{ padding: 0, display: "flex", flexDirection: "column", gap: 2 }}>
        <VideoPlayerSkeleton />
        <Container>
            <Typography variant="h4" component="h1" gutterBottom><Fake size={24}/></Typography>
            <Box mb={3}>
                <Typography variant="h5" component="h2" gutterBottom><Fake size={18}/></Typography>
                {[1,2,3].map(i => (
                    <Box key={i} mb={2}>
                        <Fake size={40}/>
                    </Box>
                ))}
            </Box>
        </Container>
    </Container>
);
